<app-auth-shell panelClass="max-w-[620px]">
  <div class="p-6 sm:p-8 lg:p-10">
    <div class="mb-8">
      <div
        class="mb-3 inline-flex rounded-full border border-periwinkle-border bg-periwinkle-soft px-3 py-1 inter-500 text-[12px] text-periwinkle"
      >
        Account recovery
      </div>
      <h1
        class="font-spaceGrotesk text-[30px] font-semibold leading-tight text-inverted-neutral sm:text-[38px]"
      >
        Reset password
      </h1>
      <p class="mt-3 inter-300 text-[15px] leading-6 text-support-text">
        Enter and confirm your new password to complete your password reset.
      </p>
    </div>

    <input
      [formControl]="resetPasswordForm.controls.newPassword"
      type="password"
      placeholder="New password"
      class="form-control mb-4"
    />

    <input
      [formControl]="resetPasswordForm.controls.confirmPassword"
      type="password"
      placeholder="Confirm password"
      class="form-control"
    />

    @if (resetPasswordForm.controls.newPassword.value && resetPasswordForm.controls.confirmPassword.value && !passwordsMatch()) {
      <div class="inter-300 text-red-500 mt-2">Passwords do not match</div>
    }

    <div class="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
      <button
        (click)="resetPassword()"
        [disabled]="resetPasswordForm.invalid || !passwordsMatch()"
        matRipple
        class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[16px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
      >
        Reset
      </button>
      <a
        [routerLink]="['/admin', 'login']"
        class="font-spaceGrotesk text-sm text-support-text transition-colors hover:text-kek-purple"
      >
        Return to login
      </a>
    </div>
  </div>
</app-auth-shell>
